module.exports = __webpack_public_path__ + "img/tertiary_10x3.b20b33ee.svg";